export default __webpack_public_path__ + "static/media/GLTD_Class_2_Plan_Brochure.2de67bc7.pdf";